import { z } from "zod";
import { statusHistoryEntrySchema } from "./status-history.schemas.js";

/** Enrichment request lifecycle states (mirrors the backend domain enum). */
export const EnrichmentRequestAdminStatusSchema = z.enum([
  "PENDING",
  "PROCESSING",
  "PARSING",
  "COMPLETED",
  "FAILED",
  "INELIGIBLE",
]);
// Projects the canonical status-history entry down to the two fields the admin
// screens render. `metadata` is deliberately omitted: it holds internal transition
// reasons that are not part of the admin contract.
export const EnrichmentRequestStatusHistoryRowSchema = statusHistoryEntrySchema(
  z.string(),
).pick({ state: true, timestamp: true });
